import { aroApiSlice } from './apiSlice';
import { getBaseURL } from '../../../utilities/config';

export const datagridApiSlice = aroApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // For searching, use the datagrid service
        getDGSearchOptions: builder.query({
            query: () => `${getBaseURL()}/query`,
            transformResponse: (response) => {
                const transformedResponse = { ...response };
                for (let table in transformedResponse) {
                    for (let field in transformedResponse[table]) {
                        if (transformedResponse[table][field].type === 'enum') {
                            const temp = transformedResponse[table][field].values.filter(
                                (v) => v !== null,
                            );
                            transformedResponse[table][field].values = temp.toSorted();
                        }
                    }
                }
                return { ...transformedResponse };
            },
            keepUnusedDataFor: 600, // 10 minutes
        }),
    }),
});

export const { useGetDGSearchOptionsQuery } = datagridApiSlice;
